import { app } from '../../../app';

class LicenseManagementService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    licenseCheck(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-check`;
        return this.$http.get(url).then(({data}) => data);
    }

    getLicenseDetails(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-details`;
        return this.$http.get(url).then(({data}) => data);
    }

    getLicenseTiers(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-tiers`;
        return this.$http.get(url).then(({data}) => data);
    }

    licensePurchase(companyId, purchaseDTO) {
        const url = `app/rest/${companyId}/licensemanagement/license-purchase`;
        return this.$http.post(url, purchaseDTO).then(({data}) => data);
    }

    upgradeLicense(companyId, purchaseDTO) {
        const url = `app/rest/${companyId}/licensemanagement/license-upgrade`;
        return this.$http.post(url, purchaseDTO).then(({data}) => data);
    }

    upgradeLicenseTier(companyId, purchaseDTO) {
        const url = `app/rest/${companyId}/licensemanagement/license-tierupgrade`;
        return this.$http.post(url, purchaseDTO).then(({data}) => data);
    }

    calculateLicenseCharges(companyId, purchaseDTO) {
        const url = `app/rest/${companyId}/licensemanagement/license-calculatecharges`;
        return this.$http.post(url, purchaseDTO).then(({data}) => data);
    }
    
    cancelAutoRenewal(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-cancelrenewal`;
        return this.$http.get(url).then(({data}) => data);
    }

    getLicenseInvoices(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-invoices`;
        return this.$http.get(url).then(({data}) => data);
    }

    getLicenseActivities(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-activities`;
        return this.$http.get(url).then(({data}) => data);
    }

    changeLicenseEmail(companyId, email) {
        const url = `app/rest/${companyId}/licensemanagement/license-changeemail?email=${email}`;
        return this.$http.get(url).then(({data}) => data);
    }

    cancelWaitingActivity(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-cancelwaitingactivity`;
        return this.$http.get(url).then(({data}) => data);
    }

    setPaymentMethod(companyId) {
        const url = `app/rest/${companyId}/licensemanagement/license-setpaymentmethod`;
        return this.$http.get(url, {transformResponse: []}).then(({data}) => data);
    }
}

app.service('LicenseManagementService', LicenseManagementService);



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-management.service.js